import React from 'react';

const InstagramOutlined = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.462 2.45c-1.111 0-2.012.9-2.012 2.012v5.075c0 1.111.9 2.012 2.012 2.012h5.075a2.01 2.01 0 0 0 2.012-2.012V4.462A2.01 2.01 0 0 0 9.537 2.45zM1.4 4.462A3.06 3.06 0 0 1 4.462 1.4h5.075a3.06 3.06 0 0 1 3.062 3.062v5.075a3.06 3.06 0 0 1-3.062 3.062H4.462A3.06 3.06 0 0 1 1.4 9.537zM7.243 5.49a1.505 1.505 0 1 0-.441 2.977 1.505 1.505 0 0 0 .441-2.977m-1.397-.78a2.555 2.555 0 1 1 2.353 4.536 2.555 2.555 0 0 1-2.353-4.535m3.946-1.026a.525.525 0 1 0 0 1.05h.004a.525.525 0 1 0 0-1.05z"
            fill="#fff"
        />
    </svg>
);
export default InstagramOutlined;
